/**
 * Form submit
 */
	window.addEventListener('load', _ => {
		'use strict'

		const forms = document.querySelectorAll('[site-validate]')
		Array.from(forms).forEach(function (form) {
			form.addEventListener('submit', function (event) {
				const button = this.querySelector('[type=submit]')
				const formReturnSuccess = form.dataset.success
				const formReturnSuccessRedirect = form.dataset.successRedirect
				const formReturnError = form.dataset.error

				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()

					const invalid = this.querySelector(':invalid')
					invalid.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
						inline: 'center'
					})
					setTimeout(() => {
						invalid.focus()
					}, 750);
				} else {
					event.preventDefault()

					const data = new FormData(this)
					const name = this.querySelector('#name').value
					const firstName = name.split(' ')[0]

					button.classList.add('is--loading')
					button.disabled = true

					const options = {
						headers: { 'Content-Type': 'multipart/form-data' }
					}

					window.axios.post(this.action, data, options)
						.then(_ => {
							form.reset()
							form.classList.remove('is--validated')

							if (formReturnSuccessRedirect) {
								setTimeout(() => {
									window.location.href = formReturnSuccessRedirect + '?name=' + firstName
								}, 500);
							} else {
								siteAlert({
									text: formReturnSuccess,
									class: 'alert--i_success',
									seconds: 12000
								})
							}
						}).catch(err => {
							console.error(err)

							siteAlert({
								text: formReturnError,
								class: 'alert--i_error',
								seconds: 7000
							})
						}).finally(_ => {
							button.classList.remove('is--loading')
							button.disabled = false
						})
				}

				form.classList.add('is--validated')
			}, false)
		})
	})


/**
 * Quantity control
 */
	const siteLess = document.querySelectorAll('[site-less]')
	const siteMore = document.querySelectorAll('[site-more]')
	const siteRemove = document.querySelectorAll('[site-cart-remove]')

	const siteSubtotal = () => {
		document.querySelectorAll('.product--i').forEach(e => {
			const priceUnity = e.querySelector('[site-cart-price]').innerHTML
			const priceQuantity = e.querySelector('[site-cart-quantity]').value
			const priceSubtotal = e.querySelector('[site-cart-subtotal]')

			let calc = parseInt(priceQuantity) * parseFloat(priceUnity.replace('.', '').replace(',', '.'))

			priceSubtotal.innerHTML = calc.toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2 })
		})
	}

	const siteTotal = () => {
		const priceTotal = document.querySelector('[site-cart-total]')
		const { url } = priceTotal.dataset;

		window.axios.get(url).then(res => {
			priceTotal.innerHTML = Intl.NumberFormat('pt-BR', {
				style: 'currency',
				currency: 'BRL',
			}).format((res.data.total));
		})
	}

	// less
	if (siteLess.length > 0) {
		siteLess.forEach(e => {
			const input = e.parentElement.querySelector('input')

			e.addEventListener('click', event => {
				const previous = parseInt(input.value, 10);

				if (input.value != 1) {
					input.value = parseInt(input.value) - 1
				}

				const url = event.currentTarget.dataset.urlUpdate;

				window.axios.put(url, { quantity : input.value }).then(res => {
					 const product = res.data;

					 const correctPrice = product.price ? product.price : product.value;

					 const subtotal = correctPrice * product.quantity;

					 const subtotalElement = input.parentElement.parentElement.querySelector('[site-cart-subtotal]');

					 subtotalElement.innerHTML = Intl.NumberFormat('pt-BR', {
																	style: 'currency',
																	currency: 'BRL',
																}).format((subtotal));

					siteTotal();
				}).catch(err => {
					input.value = previous;
					siteAlertFromAxiosError(err, 'Não foi possível atualizar a quantidade.');
				});
			});
		})
	}

	// more
	if (siteMore.length > 0) {
		siteMore.forEach(e => {
			const input = e.parentElement.querySelector('input')

			e.addEventListener('click', event => {
				const previous = parseInt(input.value, 10);
				input.value = previous + 1;

				const url = event.currentTarget.dataset.urlUpdate;

				window.axios.put(url, { quantity : input.value }).then(res => {
					 const product = res.data;

					 const correctPrice = product.price ? product.price : product.value;

					 const subtotal = correctPrice * product.quantity;

					 const subtotalElement = input.parentElement.parentElement.querySelector('[site-cart-subtotal]');

					 subtotalElement.innerHTML = Intl.NumberFormat('pt-BR', {
																	style: 'currency',
																	currency: 'BRL',
																}).format((subtotal));


					siteTotal();
				}).catch(err => {
					input.value = previous;
					siteAlertFromAxiosError(err, 'Não foi possível atualizar a quantidade.');
				});

			})
		})
	}

/**
 * Remove from cart
 */
	if (siteRemove.length > 0) {
		siteRemove.forEach(e => {
			e.addEventListener('click', event => {
				event.preventDefault();

				const element = e.parentElement.parentElement.parentElement

				if (confirm('Deseja remover este item?')) {

					const {url} = event.currentTarget.dataset;

					window.axios.delete(url).then(_ => {
						element.remove();

						const lastProduct = document.querySelectorAll('.product--i').length == 0;

						if (lastProduct) {
							document.querySelector('.product--i_row').nextElementSibling.remove()
							document.querySelector('.product--i_row').remove()
							document.querySelector('[site-cart-empty]').classList.remove('d-none')
							document.querySelector('.group [type="submit"]').disabled = true;
						}

						siteTotal();
					});

				}
			})
		})
	}
